<template>
    <div class="kit-nav">
        <div class="kit-nav__reset">
            <button v-show="$store.state.step && !$store.getters.isCartEmpty" class="btn btn-bordered" @click="reset()">
                Start over
            </button>
        </div>
        <div class="kit-nav__main">
            <button v-show="$store.state.step" class="btn btn-bordered" @click="$store.dispatch('prev')">
                {{ text.prev }}
            </button>
            <button v-show="$store.state.kitId" class="btn btn-solid" @click="$store.dispatch('next')">
                {{ text.next }}
            </button>
        </div>
    </div>
</template>

<script>
import { toRaw } from 'vue';

    export default {
        name: 'Nav',
        data() {
            return {
                text: {
                    prev: 'Previous',
                    next: 'Next'
                }
            }
        },
        watch: {
            '$store.state.step': function () {
                this.nextText();
            },
            $route (to, from){
                if (to.fullPath === `/${this.$store.state.kitId}/overview`) {
                    this.text.next = 'Add to Basket';
                } else {
                    this.nextText();
                }
            }
        },
        methods: {

            nextText() {
                
                if (this.$store.state.current && this.$store.state.current.groups.length === this.$store.state.step) {
                    this.text.next = 'Complete Kit';
                } else {
                    this.text.next = 'Next';
                }
            },

            reset() {

                const msg = 'Are you sure you want to remove all products from this kit?';

                if (confirm(msg)) {
                    this.$store.commit('resetKit')
                }

            }
        }
    }
</script>

<style lang="scss">
    .kit-nav {
        border-top: 1px solid #E5E7EC;
        padding-top: 30px;
        display: flex;
        justify-content: space-between;

        @media (max-width: 576px) {
            flex-direction: column;
            gap: 20px;
        }

        &__reset {
            button {
                @media (max-width: 576px) {
                    width: 100%;
                }
            }
        }

        &__main {
            display: flex;
            justify-content: flex-end;
            gap: 20px;

            @media (max-width: 576px) {
                display: grid;
                grid-template-columns: 1fr 1fr;
            }
        }

        button {
            padding-left: 38px;
            padding-right: 38px;

            @media (max-width: 576px) {
                padding-left: 20px;
                padding-right: 20px;
            }
        }
    }
</style>